import { observer } from 'mobx-react-lite';
import { Outlet } from 'react-router';
import { twMerge } from 'tailwind-merge';
import webViewStore from '../stores/webViewStore';
import { ModalContainer } from './common/modal/Modal';
import { NotificationBarContainer } from './common/notificationBar/NotificationBar';
import PullToRefresh from './common/PullToRefresh';
import { ToastContainer } from './common/toast/ToastContainer';
import Navbar from './Navbar';
import Sidebar, { SidebarContent } from './Sidebar';
import sidebarStore from '../stores/sidebarStore';

const Layout = observer(() => {
    return (
        <>
            <div className={twMerge('drawer')}>
                <input
                    id="sidebar"
                    type="checkbox"
                    checked={sidebarStore.isOpen}
                    className="drawer-toggle"
                    onChange={(e) => {
                        if (e.target.checked) {
                            sidebarStore.openSidebar();
                        } else {
                            sidebarStore.closeSidebar();
                        }
                    }}
                />
                <Sidebar />
                <div className="drawer-content flex flex-row">
                    <Navbar />
                    <div
                        // 레이아웃 기본
                        // - 가운데 정렬: 최대 800px (max-w-(--main-max-width))
                        // - 최소 높이는 화면 높이 (dvh 는 동적으로 화면 높이를 최대로 조정함)
                        // - 상단 패딩은 안전 높이에 Navbar 높이만큼 추가
                        // - 하단 패딩은 안전 높이에 Dock 높이만큼 추가
                        className={twMerge(
                            'mx-auto min-h-dvh w-full max-w-(--main-max-width) pt-(--navbar-height)',
                        )}
                    >
                        <div className="floating-sidebar w-(--floating-sidebar-width)">
                            <SidebarContent />
                        </div>
                        <PullToRefresh />
                        <Outlet />
                    </div>
                </div>
            </div>
            <ModalContainer />
            <NotificationBarContainer />
            <ToastContainer />
        </>
    );
});

export default Layout;
